import { RenderWhenProps } from './RenderWhen.types';

export const RenderWhen = ({ condition, children, onFalse = <></> }: RenderWhenProps) => {
  return condition ? children : onFalse;
};
